var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
// - Import react components
import moment from 'moment/moment';
// - Import action types
import { CommentActionType } from 'constants/commentActionType';
// - Import actions
import * as globalActions from 'store/actions/globalActions';
import * as notifyActions from 'store/actions/notifyActions';
import { SocialProviderTypes } from 'src/core/socialProviderTypes';
import { provider } from 'src/socialEngine';
/**
 * Get service providers
 */
var commentService = provider.get(SocialProviderTypes.CommentService);
/* _____________ CRUD DB _____________ */
/**
 *  Add comment to database
 */
export var dbAddComment = function (ownerPostUserId, newComment, callBack) {
    return function (dispatch, getState) {
        dispatch(globalActions.showTopLoading());
        var state = getState();
        var uid = state.getIn(['authorize', 'uid']);
        var currentUser = state.getIn(['user', 'info', uid]);
        var comment = {
            score: 0,
            creationDate: moment().unix(),
            userDisplayName: currentUser.fullName,
            userAvatar: currentUser.avatar,
            userId: uid,
            postId: newComment.postId,
            text: newComment.text
        };
        return commentService.addComment(comment)
            .then(function (commentKey) {
            dispatch(addComment(__assign({ id: commentKey }, comment)));
            callBack();
            dispatch(globalActions.hideTopLoading());
            if (ownerPostUserId && ownerPostUserId !== uid) {
                dispatch(notifyActions.dbAddNotification({
                    description: 'Commented on your post.',
                    url: "/" + ownerPostUserId + "/posts/" + comment.postId,
                    notifyRecieverUserId: ownerPostUserId, notifierUserId: uid,
                    isSeen: false
                }));
            }
        }, function (error) {
            dispatch(globalActions.showMessage(error.message));
            dispatch(globalActions.hideTopLoading());
        });
    };
};
/**
 * Get all comments from database
 */
export var dbFetchComments = function (ownerUserId, postId) {
    return {
        type: CommentActionType.DB_FETCH_COMMENTS,
        payload: { postId: postId, ownerUserId: ownerUserId }
    };
};
/**
 * Update a comment from database
 */
export var dbUpdateComment = function (comment) {
    return function (dispatch, getState) {
        dispatch(globalActions.showTopLoading());
        return commentService.updateComment(comment)
            .then(function () {
            dispatch(updateComment(comment));
            dispatch(closeCommentEditor(comment));
            dispatch(globalActions.hideTopLoading());
        }, function (error) {
            dispatch(globalActions.showMessage(error.message));
            dispatch(globalActions.hideTopLoading());
        });
    };
};
/**
 * Delete a comment from database
 */
export var dbDeleteComment = function (id, postId) {
    return function (dispatch, getState) {
        if (id === undefined || id === null) {
            dispatch(globalActions.showMessage('comment id can not be null or undefined'));
        }
        dispatch(globalActions.showTopLoading());
        return commentService.deleteComment(id)
            .then(function () {
            dispatch(deleteComment(id, postId));
            dispatch(globalActions.hideTopLoading());
        }, function (error) {
            dispatch(globalActions.showMessage(error.message));
            dispatch(globalActions.hideTopLoading());
        });
    };
};
/* _____________ CRUD State _____________ */
/**
 * Add comment
 * @param {Comment} data
 */
export var addComment = function (comment) {
    return {
        type: CommentActionType.ADD_COMMENT,
        payload: comment
    };
};
/**
 * Update comment
 */
export var updateComment = function (comment) {
    return {
        type: CommentActionType.UPDATE_COMMENT,
        payload: { comment: comment }
    };
};
/**
 * Add comment list
 * @param {[postId: string]: {[commentId: string] : Comment}} postComments an array of comments
 */
export var addCommentList = function (postComments) {
    return {
        type: CommentActionType.ADD_COMMENT_LIST,
        payload: postComments
    };
};
/**
 * Delete a comment
 */
export var deleteComment = function (id, postId) {
    return { type: CommentActionType.DELETE_COMMENT, payload: { id: id, postId: postId } };
};
/**
 * Clear all data
 */
export var clearAllData = function () {
    return {
        type: CommentActionType.CLEAR_ALL_DATA_COMMENT
    };
};
export var openCommentEditor = function (comment) {
    return {
        type: CommentActionType.OPEN_COMMENT_EDITOR,
        payload: comment
    };
};
export var closeCommentEditor = function (comment) {
    return {
        type: CommentActionType.CLOSE_COMMENT_EDITOR,
        payload: comment
    };
};



//////////////////
// WEBPACK FOOTER
// ./src/store/actions/commentActions.ts
// module id = 393
// module chunks = 50